import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateCourseReport,
  fetchCourseReports,
} from "../../../../reduxToolkit/features/CourseImprovement/courseImprovementSlice";
import { fetchGroupStatesByReport } from "reduxToolkit/features/groupState/GroupStateSlice";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Link, useParams } from "react-router-dom";
import "@lourenci/react-kanban/dist/styles.css";
import { unwrapResult } from "@reduxjs/toolkit";
import { Breadcrumb } from "antd";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import DropDownButtonCourseReport from "../../../Components/DropDownButtonCourseReport";
import ErrorModal from "../../../Components/ErrorModal";
import Info from "components/Typography/Info.js";
import { fetchStaff } from "../../../../reduxToolkit/features/user/UserSlice";
import DNDBoard from "../../../../components/dnd/Board";

export default function CourseImprovementList(props) {
  const initialBoard = {
    columns: [],
  };
  let content;
  let draftBoard;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { type } = useParams();
  const [board, setBoard] = useState(initialBoard);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  useEffect(() => {
    courseReportsAccordingToStates();
    dispatch(fetchStaff());
  }, []);

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  function deepCopy(obj) {
    let newObj = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        newObj[key] = deepCopy(obj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  const courseReportsAccordingToStates = () => {
    dispatch(fetchGroupStatesByReport("CourseReport"))
      .then(unwrapResult)
      .then((states) => {
        if (states?.columns?.length > 0) {
          draftBoard = deepCopy(states);
          dispatch(fetchCourseReports())
            .then(unwrapResult)
            .then((CourseReports) => {
              if (type !== "NCAAA") { CourseReports = [] }
              if (CourseReports?.length > 0) {
                CourseReports.forEach((report) => {
                  let stateObject = report.state_object;
                  let column = draftBoard?.columns?.find(
                    (col) => col.title === stateObject
                  );
                  if (column && column.cards) {
                    // Ensure cards array exists
                    column.cards.push(report);
                  }
                });
              }
              setBoard(draftBoard);
            })
            .catch((error) => {
              setHandledError(error);
              handleOpenErrorModal();
            });
        }
      })
      .catch((error) => {
        setHandledError(error);
        handleOpenErrorModal();
      });
  };

  const handleDragEnd = async (result) => {
    const { destination, source, draggableId } = result;

    if (!destination || source.droppableId == destination.droppableId) return;

    const destinationState = board.columns.find(
      (state) => state.id == destination.droppableId
    );
    const report = CourseReports.find((report) => report.id == draggableId);
    const state_object = destinationState?.title;

    if (state_object && report) {
      // Dispatch the update request

      try {
        dispatch(
          UpdateCourseReport({
            id: report.id,
            updatedCourseReport: { ...report, sent_to: report.assign_to, state_object },
          })
        ).unwrap();
        // handle result here
        // If the request is successful, update the state
        const updatedColumns = board.columns.map((column) => {
          if (column.id == source.droppableId) {
            // Remove the report from the source column
            column.cards = column.cards.filter((card) => card.id !== report.id);
          } else if (column.id == destination.droppableId) {
            // Add the report to the destination column
            column.cards.push(report);
          }
          return column;
        });

        // Update the state with the new columns structure
        setBoard((prevBoard) => ({ ...prevBoard, columns: updatedColumns }));
      } catch (rejectedValueOrSerializedError) {
        // handle error here
        setHandledError(rejectedValueOrSerializedError);
        handleOpenErrorModal();
      }
    }
  };

  const CourseReportsStatus = useSelector(
    (state) => state.CourseReport.courseReportsStatus
  );

  const CourseReport_StateBoard = useSelector(
    (state) => state.groupState.groupStatesByReport
  );

  const groupStatesByReportStatus = useSelector(
    (state) => state.groupState.groupStatesByReportStatus
  );

  const CourseReports = useSelector(
    (state) => state.CourseReport.CourseReports
  );
  const staffList = useSelector((state) => state.user.staffList);

  const renderCardContent = (report, showDropDown) => (
    <div>
      <GridContainer alignItems="baseline" style={{ minHeight: "80px" }}>
        <GridItem
          key={Element.id}
          xs={showDropDown ? 12 : 12}
          sm={showDropDown ? 9 : 12}
          md={showDropDown ? 9 : 12}
          lg={showDropDown ? 10 : 12}
        >
          <Link to={`/citrine/reports/${type}/course/${report.id}`}>
            <strong>
              <p style={{ marginTop: "10px" }}>{report?.course?.[0]?.title}</p>
            </strong>
          </Link>
          {/* {Moment(report.date).format("YYYY-MM-DD")} */}
        </GridItem>
        {showDropDown && (
          <GridItem key={Element.id} xs={12} sm={3} md={3} lg={2}>
            <DropDownButtonCourseReport
              data={report}
              id={report.id}
              staffList={staffList}
              orderReportsAccordingToStates={courseReportsAccordingToStates}
            />
          </GridItem>
        )}
      </GridContainer>
      <p style={{ fontSize: "12px" }}>
        {report?.course?.[0]?.academic_year}/
        {report?.course?.[0]?.semester?.name}
      </p>
    </div>
  );

  if (
    CourseReportsStatus === "loading" ||
    groupStatesByReportStatus === "loading"
  ) {
    content = (
      <GridContainer
        style={{ height: "100%" }}
        justifyContent="center"
        alignItems="center"
      >
        <GridItem>
          <CircularProgress color="inherit" />
        </GridItem>
      </GridContainer>
    );
  }

  if (
    CourseReportsStatus === "failed" ||
    groupStatesByReportStatus === "failed"
  ) {
    return (
      <GridContainer justifyContent="center" alignItems="center">
        <GridItem style={{ width: "60%" }}>
          <Info>
            Oops! Something went wrong. We're having trouble retrieving the
            course reports. Please try again later. If the issue persists,
            contact support for assistance.
          </Info>
        </GridItem>
      </GridContainer>
    );
  }

  if (groupStatesByReportStatus === "succeeded") {
    if (CourseReport_StateBoard?.columns?.length == 0) {
      content = (
        <GridContainer justifyContent="center" alignItems="center">
          <GridItem style={{ width: "60%" }}>
            <Info>
              Oops! Something went wrong. We could not find any course reports
              states. Please add the needed states in the configuration menu or
              contact support for assistance.
            </Info>
          </GridItem>
        </GridContainer>
      );
    }

    if (CourseReportsStatus === "succeeded") {
      content = (
        <DNDBoard
          columns={board}
          renderCardContent={renderCardContent}
          handleDragEnd={handleDragEnd}
        />
      );
    }
  }

  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <Link to={`/citrine/reports/${type}/course`}>
            {t("Course Report")}
          </Link>
        </Breadcrumb.Item>
      </Breadcrumb>

      {content}

      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </>
  );
}
